import { config } from "../../utils/constants";
import axios from "axios";

export const getQmaticInformation = () => {
  const requestConfig = {
    method: 'POST',
    url: `${config.smartregistration}/get-ticketdetails`
  };

  return axios.request(requestConfig);
};

export const generateBarCode = (content) => {
  const requestConfig = {
    url: `${config.smartregistration}/barcode/${content}`
  };

  return axios.request(requestConfig);
};

export const generateQrCode = (content) => {
  const requestConfig = {
    url: `${config.smartregistration}/qrcode/${content}`
  };

  return axios.request(requestConfig);
};